import React, {useEffect} from 'react';
import {createGlobalStyle} from 'styled-components';
import {BANNER_HEIGHT, externalBannerPosition} from './positioning';
import {
  BAR,
  CONTAINER,
  EXTERNAL_BANNER_HOST,
  useExternalBannerHeight
} from './externalBanner';

const ExternalBannerStyle = createGlobalStyle`
  body.${EXTERNAL_BANNER_HOST} > ${CONTAINER} {
    min-height: 0;
    height: 0;
  }

  body.${EXTERNAL_BANNER_HOST} ${CONTAINER} > ${BAR} {
    ${externalBannerPosition}
    min-height: ${BANNER_HEIGHT}px;
    height: auto;
  }
`;

const ExternalNotificationBanner = () => {
  useExternalBannerHeight();

  useEffect(() => {
    document.body.classList.add(EXTERNAL_BANNER_HOST);
    return () => document.body.classList.remove(EXTERNAL_BANNER_HOST);
  }, []);

  return <ExternalBannerStyle />;
};

export default ExternalNotificationBanner;
